module.exports = "/_next/static/images/f8b034363b8a12bdd1929c165bf60667-Nubank_HickDuarte_58654 (2) 1_md.jpg";